"use strict";

/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/
(function () {
  /******/"use strict";

  /******/
  var __webpack_modules__ = {
    /***/"./components/src/icons/index.ts": (
    /*!***************************************!*\
      !*** ./components/src/icons/index.ts ***!
      \***************************************/
    /***/
    function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
      eval("__webpack_require__.r(__webpack_exports__);\n/* harmony export */ __webpack_require__.d(__webpack_exports__, {\n/* harmony export */   EGDSIcon: function() { return /* reexport safe */ uitk_react_icons__WEBPACK_IMPORTED_MODULE_0__.UitkIcon; },\n/* harmony export */   EGDSIconSize: function() { return /* reexport safe */ uitk_react_icons__WEBPACK_IMPORTED_MODULE_0__.UitkIconSize; },\n/* harmony export */   UitkIcon: function() { return /* reexport safe */ uitk_react_icons__WEBPACK_IMPORTED_MODULE_0__.UitkIcon; },\n/* harmony export */   UitkIconSize: function() { return /* reexport safe */ uitk_react_icons__WEBPACK_IMPORTED_MODULE_0__.UitkIconSize; },\n/* harmony export */   attributize: function() { return /* reexport safe */ uitk_react_icons__WEBPACK_IMPORTED_MODULE_0__.attributize; },\n/* harmony export */   getMarkerPopup: function() { return /* reexport safe */ uitk_react_icons__WEBPACK_IMPORTED_MODULE_0__.getMarkerPopup; },\n/* harmony export */   getMetaData: function() { return /* reexport safe */ uitk_react_icons__WEBPACK_IMPORTED_MODULE_0__.getMetaData; }\n/* harmony export */ });\n/* harmony import */ var uitk_react_icons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! uitk-react-icons */ \"uitk-react-icons\");\n/* harmony import */ var uitk_react_icons__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(uitk_react_icons__WEBPACK_IMPORTED_MODULE_0__);\n\n\n//# sourceURL=webpack://@egds/react-core/./components/src/icons/index.ts?");
      /***/
    }),
    /***/"uitk-react-icons": (
    /*!***********************************!*\
      !*** external "uitk-react-icons" ***!
      \***********************************/
    /***/
    function (module) {
      module.exports = require("uitk-react-icons");
      /***/
    })
    /******/
  };
  /************************************************************************/
  /******/ // The module cache
  /******/
  var __webpack_module_cache__ = {};
  /******/
  /******/ // The require function
  /******/
  function __webpack_require__(moduleId) {
    /******/ // Check if module is in cache
    /******/var cachedModule = __webpack_module_cache__[moduleId];
    /******/
    if (cachedModule !== undefined) {
      /******/return cachedModule.exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/
    var module = __webpack_module_cache__[moduleId] = {
      /******/ // no module.id needed
      /******/ // no module.loaded needed
      /******/exports: {}
      /******/
    };
    /******/
    /******/ // Execute the module function
    /******/
    __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
    /******/
    /******/ // Return the exports of the module
    /******/
    return module.exports;
    /******/
  }
  /******/
  /************************************************************************/
  /******/ /* webpack/runtime/compat get default export */
  /******/
  !function () {
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
      /******/var getter = module && module.__esModule ? /******/function () {
        return module['default'];
      } : /******/function () {
        return module;
      };
      /******/
      __webpack_require__.d(getter, {
        a: getter
      });
      /******/
      return getter;
      /******/
    };
    /******/
  }();
  /******/
  /******/ /* webpack/runtime/define property getters */
  /******/
  !function () {
    /******/ // define getter functions for harmony exports
    /******/__webpack_require__.d = function (exports, definition) {
      /******/for (var key in definition) {
        /******/if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
          /******/Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
          /******/
        }
        /******/
      }
      /******/
    };
    /******/
  }();
  /******/
  /******/ /* webpack/runtime/hasOwnProperty shorthand */
  /******/
  !function () {
    /******/__webpack_require__.o = function (obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    };
    /******/
  }();
  /******/
  /******/ /* webpack/runtime/make namespace object */
  /******/
  !function () {
    /******/ // define __esModule on exports
    /******/__webpack_require__.r = function (exports) {
      /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
        /******/Object.defineProperty(exports, Symbol.toStringTag, {
          value: 'Module'
        });
        /******/
      }
      /******/
      Object.defineProperty(exports, '__esModule', {
        value: true
      });
      /******/
    };
    /******/
  }();
  /******/
  /************************************************************************/
  /******/
  /******/ // startup
  /******/ // Load entry module and return exports
  /******/ // This entry module can't be inlined because the eval devtool is used.
  /******/
  var __webpack_exports__ = __webpack_require__("./components/src/icons/index.ts");
  /******/
  module.exports = __webpack_exports__;
  /******/
  /******/
})();